    const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyfS2kd1CkeQchm0Dvp5FwwvEYsBtt_ppkxzfxAeMzHWpg0L53kDL0Q7zqC5ODSYYkZ9g/exec';
    let items = [];
    let currentMaterial = '';
    let currentQuality = '';
    let currentThickness = '';
    let currentImageUrl = '';
    let createdProductId;
    let createdVariantId;

    function roundToFiveHUF(price) {
      if (typeof price !== 'number' || isNaN(price)) {
        console.error('Érvénytelen ár érték:', price);
        return 0;
      }
      return Math.ceil(price / 5) * 5;
    }
    
    const cache = {
      materials: null,
      qualities: {},
      thicknesses: {},
      productDetails: {},
      edgeProcessing: {},
      surfaceTreatment: {},
      customShape: {},
      preloadQueue: [],
      isPreloading: false
    };

    const eventHandlers = {};

    async function fetchData(functionName, params) {
      try {
        return await google.script.run
          .withSuccessHandler(function(result) {
            return result;
          })
          .withFailureHandler(function(error) {
            console.error('Server error:', error);
            throw error;
          })[functionName](params.material, params.quality, params.thickness);
      } catch (error) {
        console.error('Fetch error:', error);
        throw error;
      }
    }

    const loadingOverlay = {
      show() {
        document.getElementById('loadingOverlay').style.display = 'flex';
      },
      hide() {
        document.getElementById('loadingOverlay').style.display = 'none';
      }
    };

    async function preloadNextItems() {
      if (cache.isPreloading || cache.preloadQueue.length === 0) return;
      
      cache.isPreloading = true;
      
      try {
        while (cache.preloadQueue.length > 0) {
          const item = cache.preloadQueue.shift();
          const { material, quality, thickness } = item;
          
          // Minőségek előre betöltése
          if (!cache.qualities[material]) {
            const qualitiesResponse = await fetchData('getQualities', { material });
            if (qualitiesResponse.success) {
              cache.qualities[material] = qualitiesResponse.data;
            }
          }
          
          // Vastagságok előre betöltése
          if (quality) {
            const cacheKey = `${material}_${quality}`;
            if (!cache.thicknesses[cacheKey]) {
              const thicknessesResponse = await fetchData('getThicknesses', { material, quality });
              if (thicknessesResponse.success) {
                cache.thicknesses[cacheKey] = thicknessesResponse.data;
              }
            }
          }
          
          // Termék részletek előre betöltése
          if (thickness) {
            const cacheKey = `${material}_${quality}_${thickness}`;
            if (!cache.productDetails[cacheKey]) {
              const detailsResponse = await fetchData('getProductDetails', { material, quality, thickness });
              if (detailsResponse.success) {
                cache.productDetails[cacheKey] = detailsResponse.data;
              }
            }
          }
        }
      } catch (error) {
        console.error('Előre betöltési hiba:', error);
      } finally {
        cache.isPreloading = false;
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      validateContactForm();
    });

    document.addEventListener('DOMContentLoaded', async () => {
      loadingOverlay.show();
      
      try {
        // Faanyagok lekérése
        const response = await fetchData('getMaterials');
        if (response.success && Array.isArray(response.data)) {
          cache.materials = response.data;
          
          // Előre betöltési sorhoz hozzáadás
          cache.materials.forEach(material => {
            cache.preloadQueue.push({ material });
          });
          
          // Előre betöltés indítása
          preloadNextItems();
          
          // Első tétel hozzáadása
          addNewItem();
        } else {
          throw new Error('Érvénytelen válasz formátum');
        }
      } catch (error) {
        console.error('Error details:', error);
        showError('Hiba történt az adatok betöltésekor');
      } finally {
        loadingOverlay.hide();
      }
    });

    function createItemHTML(itemId, itemNumber) {
      return `
        <div class="item-container" id="item-${itemId}">
          <div class="item-header">
            <span class="item-title">Tétel #${itemNumber}</span>
          </div>
          
          <div class="form-group">
            <label for="material-${itemId}">Faanyag</label>
            <select id="material-${itemId}" onchange="handleMaterialChange('${itemId}')">
              <option value="">Válasszon faanyagot</option>
              ${cache.materials ? cache.materials.map(material => 
                `<option value="${material}">${material}</option>`
              ).join('') : ''}
            </select>
          </div>
          
          <div class="form-group">
            <label for="quality-${itemId}">Minőségi kategória</label>
            <select id="quality-${itemId}" onchange="handleQualityChange('${itemId}')" disabled>
              <option value="">Először válasszon faanyagot</option>
            </select>
          </div>
          
          <div class="form-group">
            <label for="thickness-${itemId}">Vastagság</label>
            <select id="thickness-${itemId}" onchange="handleThicknessChange('${itemId}')" disabled>
              <option value="">Először válasszon minőséget</option>
            </select>
          </div>
    
          <img id="preview-${itemId}" class="material-preview" style="display: none;" alt="Anyag előnézet">
          <div id="parameters-${itemId}" class="product-parameters"></div>

    
          <div class="dimensions">
            <div class="form-group">
              <label for="width-${itemId}">Hosszúság (mm)</label>
              <input type="number" id="width-${itemId}" min="100" max="3000" required onchange="updatePrices()">
            </div>
            <div class="form-group">
              <label for="height-${itemId}">Szélesség (mm)</label>
              <input type="number" id="height-${itemId}" min="100" max="3000" required onchange="updatePrices()">
            </div>
          </div>
    
          <!-- Él megmunkálás opciók -->
          <div class="edge-processing-container">
            <div class="form-group">
              <label for="edge-processing-${itemId}">Él megmunkálás</label>
              <select id="edge-processing-${itemId}" onchange="updatePrices()">
                <option value="">Válasszon él megmunkálást</option>
              </select>
            </div>
            
            <div class="edge-checkboxes">
              <div class="edge-visual">
                <!-- Felső él -->
                <div class="edge-checkbox top">
                  <input type="checkbox" id="edge-top-${itemId}" onchange="updatePrices()">
                  <label for="edge-top-${itemId}">Hosszúsági oldal fent</label>
                </div>
                
                <!-- Jobb él -->
                <div class="edge-checkbox right">
                  <input type="checkbox" id="edge-right-${itemId}" onchange="updatePrices()">
                  <label for="edge-right-${itemId}">Szélességi oldal jobb</label>
                </div>
                
                <!-- Alsó él -->
                <div class="edge-checkbox bottom">
                  <input type="checkbox" id="edge-bottom-${itemId}" onchange="updatePrices()">
                  <label for="edge-bottom-${itemId}">Hosszúsági oldal lent</label>
                </div>
                
                <!-- Bal él -->
                <div class="edge-checkbox left">
                  <input type="checkbox" id="edge-left-${itemId}" onchange="updatePrices()">
                  <label for="edge-left-${itemId}">Szélességi oldal bal</label>
                </div>
                
                <!-- Vizuális téglalap -->
                <div class="edge-rectangle"></div>
              </div>
            </div>
          </div>
    
          <!-- Felületkezelés opció -->
          <div class="form-group">
            <label for="surface-treatment-${itemId}">Felületkezelés</label>
            <select id="surface-treatment-${itemId}" onchange="updatePrices()">
              <option value="">Válasszon felületkezelést</option>
            </select>
          </div>
    
          <!-- Egyedi forma opció -->
          <div class="form-group">
            <label for="custom-shape-${itemId}">Egyedi forma</label>
            <select id="custom-shape-${itemId}" onchange="updatePrices()">
              <option value="">Válasszon egyedi formát</option>
            </select>
          </div>
    
          <div class="form-group">
            <label for="quantity-${itemId}">Mennyiség (db)</label>
            <input type="number" id="quantity-${itemId}" min="1" required oninput="updatePrices()">
          </div>
    
          <div class="file-upload-container">
            <label for="files-${itemId}">Itt tölthet fel terveket, vázlatrajzokat, ami alapján elkészítjük az egyedi táblákat (csak képformátum feltöltése megengedett)</label>
            <input type="file" id="files-${itemId}" multiple accept="image/*" 
                   onchange="handleFileUpload('${itemId}')">
            <div class="file-upload-list" id="fileList-${itemId}"></div>
          </div>
    
          <div class="result">
            <p>Darabár:</p>
            <p class="price" id="unitPrice-${itemId}">0 Ft</p>
            <p>Él megmunkálás díja:</p>
            <p class="price" id="edgePrice-${itemId}">0 Ft</p>
            <p>Felületkezelés díja:</p>
            <p class="price" id="surfacePrice-${itemId}">0 Ft</p>
            <p>Egyedi forma díja:</p>
            <p class="price" id="shapePrice-${itemId}">0 Ft</p>
            <p>Tételérték:</p>
            <p class="price" id="itemTotal-${itemId}">0 Ft</p>
          </div>
    
          ${items.length > 0 ? `
            <button type="button" class="remove-item-btn" onclick="removeItem('${itemId}')">
              Tétel törlése
            </button>
          ` : ''}
        </div>
      `;
    }

    function addNewItem() {
      const itemId = Date.now().toString();
      items.push(itemId);
      
      document.getElementById('itemsList').insertAdjacentHTML(
        'beforeend', 
        createItemHTML(itemId, items.length)
      );
    
      // Opcionális szolgáltatások betöltése
      loadOptionalServices(itemId);
    }

    function removeItem(itemId) {
      document.getElementById(`item-${itemId}`).remove();
      items = items.filter(id => id !== itemId);
      
      items.forEach((id, index) => {
        const titleElement = document.querySelector(`#item-${id} .item-title`);
        if (titleElement) {
          titleElement.textContent = `Tétel #${index + 1}`;
        }
      });
      
      updatePrices();
    }

    async function handleMaterialChange(itemId) {
      const materialSelect = document.getElementById(`material-${itemId}`);
      const qualitySelect = document.getElementById(`quality-${itemId}`);
      const thicknessSelect = document.getElementById(`thickness-${itemId}`);
      const previewImg = document.getElementById(`preview-${itemId}`);
      const lengthInput = document.getElementById(`width-${itemId}`);
      const widthInput = document.getElementById(`height-${itemId}`);
      
      // Régi eseménykezelők eltávolítása
      removeOldEventHandlers(itemId);
      
      // Méret mezők és korlátok alaphelyzetbe állítása
      lengthInput.value = '';
      lengthInput.removeAttribute('max');
      widthInput.value = '';
      widthInput.removeAttribute('max');
      
      const material = materialSelect.value;
      if (!material) {
        resetItemSelections(itemId);
        return;
      }
    
      loadingOverlay.show();
    
      try {
        let qualities;
        if (cache.qualities[material]) {
          qualities = cache.qualities[material];
        } else {
          const response = await fetchData('getQualities', { material });
          if (response.success && Array.isArray(response.data)) {
            qualities = response.data;
            cache.qualities[material] = qualities;
            
            qualities.forEach(quality => {
              cache.preloadQueue.push({ material, quality });
            });
            
            preloadNextItems();
          } else {
            throw new Error('Érvénytelen minőségi kategória adatok');
          }
        }
    
        qualitySelect.innerHTML = '<option value="">Válasszon minőséget</option>' +
          qualities.map(quality => `<option value="${quality}">${quality}</option>`).join('');
        qualitySelect.disabled = false;
        
        // Vastagság select alaphelyzetbe állítása
        thicknessSelect.innerHTML = '<option value="">Először válasszon minőséget</option>';
        thicknessSelect.disabled = true;
        
        previewImg.style.display = 'none';
        previewImg.src = '';
    
        // Árak frissítése a változtatás után
        updatePrices();
    
      } catch (error) {
        console.error('Error:', error);
        showError('Hiba történt az adatok betöltésekor');
      } finally {
        loadingOverlay.hide();
      }
    }

    async function handleQualityChange(itemId) {
      const materialSelect = document.getElementById(`material-${itemId}`);
      const qualitySelect = document.getElementById(`quality-${itemId}`);
      const thicknessSelect = document.getElementById(`thickness-${itemId}`);
      const previewImg = document.getElementById(`preview-${itemId}`);
      const lengthInput = document.getElementById(`width-${itemId}`);
      const widthInput = document.getElementById(`height-${itemId}`);
      
      // Régi eseménykezelők eltávolítása
      removeOldEventHandlers(itemId);
      
      // Méret mezők és korlátok alaphelyzetbe állítása
      lengthInput.value = '';
      lengthInput.removeAttribute('max');
      widthInput.value = '';
      widthInput.removeAttribute('max');
      
      const material = materialSelect.value;
      const quality = qualitySelect.value;
      
      if (!quality) {
        thicknessSelect.innerHTML = '<option value="">Először válasszon minőséget</option>';
        thicknessSelect.disabled = true;
        previewImg.style.display = 'none';
        updatePrices();
        return;
      }
    
      loadingOverlay.show();
    
      try {
        const cacheKey = `${material}_${quality}`;
        let thicknesses;
        
        if (cache.thicknesses[cacheKey]) {
          thicknesses = cache.thicknesses[cacheKey];
        } else {
          const response = await fetchData('getThicknesses', { material, quality });
          if (response.success && Array.isArray(response.data)) {
            thicknesses = response.data;
            cache.thicknesses[cacheKey] = thicknesses;
    
            thicknesses.forEach(thickness => {
              const detailsCacheKey = `${material}_${quality}_${thickness}`;
              if (!cache.productDetails[detailsCacheKey]) {
                cache.preloadQueue.push({ material, quality, thickness });
              }
            });
            
            preloadNextItems();
          } else {
            throw new Error('Érvénytelen vastagság adatok');
          }
        }
    
        thicknessSelect.innerHTML = '<option value="">Válasszon vastagságot</option>' +
          thicknesses.map(thickness => `<option value="${thickness}">${thickness}</option>`).join('');
        thicknessSelect.disabled = false;
        
        previewImg.style.display = 'none';
        previewImg.src = '';
    
        // Árak frissítése a változtatás után
        updatePrices();
    
      } catch (error) {
        console.error('Error:', error);
        showError('Hiba történt az adatok betöltésekor');
        thicknessSelect.innerHTML = '<option value="">Hiba történt</option>';
        thicknessSelect.disabled = true;
        previewImg.style.display = 'none';
      } finally {
        loadingOverlay.hide();
      }
    }

    function removeOldEventHandlers(itemId) {
      const lengthInput = document.getElementById(`width-${itemId}`);
      const widthInput = document.getElementById(`height-${itemId}`);
      
      // Ha vannak régi eseménykezelők, eltávolítjuk őket
      if (eventHandlers[itemId]) {
        const { lengthHandler, widthHandler } = eventHandlers[itemId];
        if (lengthHandler) {
          lengthInput.removeEventListener('input', lengthHandler);
        }
        if (widthHandler) {
          widthInput.removeEventListener('input', widthHandler);
        }
      }
    }

    function convertDriveUrl(url) {
      if (!url) return '';
      
      // Ha már teljes URL-t kaptunk, visszaadjuk
      if (url.startsWith('http')) return url;
      
      // Ha Drive fájl ID-t kaptunk, generáljuk a megfelelő URL-t
      return `https://drive.google.com/uc?export=view&id=${url}`;
    }

    async function handleThicknessChange(itemId) {
      const materialSelect = document.getElementById(`material-${itemId}`);
      const qualitySelect = document.getElementById(`quality-${itemId}`);
      const thicknessSelect = document.getElementById(`thickness-${itemId}`);
      const previewImg = document.getElementById(`preview-${itemId}`);
      const lengthInput = document.getElementById(`width-${itemId}`);
      const widthInput = document.getElementById(`height-${itemId}`);
      const parametersDiv = document.getElementById(`parameters-${itemId}`);
      
      if (eventHandlers[itemId]) {
        const { lengthHandler, widthHandler } = eventHandlers[itemId];
        if (lengthHandler) lengthInput.removeEventListener('input', lengthHandler);
        if (widthHandler) widthInput.removeEventListener('input', widthHandler);
        delete eventHandlers[itemId];
      }
      
      // Méret mezők és korlátok alaphelyzetbe állítása
      lengthInput.value = '';
      lengthInput.removeAttribute('max');
      widthInput.value = '';
      widthInput.removeAttribute('max');
      
      const material = materialSelect.value;
      const quality = qualitySelect.value;
      const thickness = thicknessSelect.value;
      
      if (!material || !quality || !thickness) {
        if (previewImg) previewImg.style.display = 'none';
        if (parametersDiv) parametersDiv.innerHTML = '';
        updatePrices();
        return;
      }
    
      try {
        const cacheKey = `${material}_${quality}_${thickness}`;
        let productDetails;
        
        if (cache.productDetails[cacheKey]) {
          productDetails = cache.productDetails[cacheKey];
        } else {
          const response = await fetchData('getProductDetails', { material, quality, thickness });
          if (!response || !response.success) {
            throw new Error(response?.error || 'Hiba történt az adatok betöltésekor');
          }
          productDetails = response.data;
          cache.productDetails[cacheKey] = productDetails;
        }
    
        if (productDetails.kép_url) {
          const imageUrl = convertDriveUrl(productDetails.kép_url);
          previewImg.onload = () => {
            previewImg.style.display = 'block';
          };
          
          previewImg.onerror = () => {
            console.error('Kép betöltési hiba:', imageUrl);
            if (imageUrl.includes('drive.google.com')) {
              const fileId = imageUrl.match(/id=([^&]+)/)?.[1];
              if (fileId) {
                previewImg.src = `https://drive.google.com/thumbnail?id=${fileId}&sz=w800`;
              } else {
                previewImg.style.display = 'none';
              }
            } else {
              previewImg.style.display = 'none';
            }
          };
        
          previewImg.src = imageUrl;
        } else {
          previewImg.style.display = 'none';
        }
    
        if (parametersDiv) {
          parametersDiv.innerHTML = `
            <div class="product-parameters">
              <p><strong>Faanyag:</strong> ${material}</p>
              <p><strong>Minőségi kategória:</strong> ${quality}</p>
              <p><strong>Vastagság:</strong> ${thickness} mm</p>
              <p><strong>Maximális hosszúság:</strong> ${productDetails.maxLength} mm</p>
              <p><strong>Maximális szélesség:</strong> ${productDetails.maxWidth} mm</p>
            </div>
          `;
        }
    
        // Méret mezők korlátainak beállítása és engedélyezése
        lengthInput.max = productDetails.maxLength;
        widthInput.max = productDetails.maxWidth;
        lengthInput.disabled = false;
        widthInput.disabled = false;
    
        // Új eseménykezelők létrehozása és tárolása
        const lengthHandler = function() {
          const value = parseInt(this.value);
          if (value > productDetails.maxLength) {
            this.value = productDetails.maxLength;
            showError('Csak a kiválasztott tábla maximális méreteiben adhat meg értéket');
          }
          updatePrices();
        };

        const widthHandler = function() {
          const value = parseInt(this.value);
          if (value > productDetails.maxWidth) {
            this.value = productDetails.maxWidth;
            showError('Csak a kiválasztott tábla maximális méreteiben adhat meg értéket');
          }
          updatePrices();
        };

        // Új eseménykezelők hozzáadása
        lengthInput.addEventListener('input', lengthHandler);
        widthInput.addEventListener('input', widthHandler);

        // Eseménykezelők tárolása
        eventHandlers[itemId] = {
          lengthHandler,
          widthHandler
        };
    
        // Árak frissítése a változtatás után
        updatePrices();
    
      } catch (error) {
        console.error('Error:', error);
        showError(error.message || 'Hiba történt az adatok betöltésekor');
        if (previewImg) previewImg.style.display = 'none';
        if (parametersDiv) parametersDiv.innerHTML = '';
        lengthInput.disabled = true;
        widthInput.disabled = true;
      }
    }

    async function loadOptionalServices(itemId) {
      try {
        // Él megmunkálás opciók betöltése
        const edgeResponse = await fetchData('getServiceOptions', { service: 'edge_processing' });
        if (edgeResponse.success) {
          cache.edgeProcessing = edgeResponse.data;
          const edgeSelect = document.getElementById(`edge-processing-${itemId}`);
          edgeSelect.innerHTML = '<option value="">Válasszon él megmunkálást</option>' +
            edgeResponse.data.map(option => 
              `<option value="${option.name}" data-price="${option.price}">${option.name}</option>`
            ).join('');
        }
    
        // Felületkezelés opciók betöltése
        const surfaceResponse = await fetchData('getServiceOptions', { service: 'surface_treatment' });
        if (surfaceResponse.success) {
          cache.surfaceTreatment = surfaceResponse.data;
          const surfaceSelect = document.getElementById(`surface-treatment-${itemId}`);
          surfaceSelect.innerHTML = '<option value="">Válasszon felületkezelést</option>' +
            surfaceResponse.data.map(option => 
              `<option value="${option.name}" data-price="${option.price}">${option.name}</option>`
            ).join('');
        }
    
        // Egyedi forma opciók betöltése
        const shapeResponse = await fetchData('getServiceOptions', { service: 'custom_shape' });
        if (shapeResponse.success) {
          cache.customShape = shapeResponse.data;
          const shapeSelect = document.getElementById(`custom-shape-${itemId}`);
          shapeSelect.innerHTML = '<option value="">Válasszon egyedi formát</option>' +
            shapeResponse.data.map(option => 
              `<option value="${option.name}" data-price="${option.price}">${option.name}</option>`
            ).join('');
        }
      } catch (error) {
        console.error('Hiba az opcionális szolgáltatások betöltésekor:', error);
        showError('Hiba történt a szolgáltatások betöltésekor');
      }
    }

    function processShopifyImages(imageUrl) {
      if (!imageUrl) return null;
      
      try {
        const fileId = imageUrl.match(/id=([^&]+)/)?.[1];
        if (fileId) {
          // Nagy felbontású kép URL a Shopify számára
          return `https://drive.google.com/uc?export=view&id=${fileId}`;
        }
        return imageUrl;
      } catch (error) {
        console.error('Hiba a Shopify kép feldolgozása során:', error);
        return null;
      }
    }

    function formatDriveImageUrl(url) {
      if (!url) return '';
      
      // Ha már formázott URL-t kaptunk, visszaadjuk
      if (url.startsWith('http')) return url;
      
      // Google Drive ID esetén thumbnail URL generálása
      return `https://drive.google.com/thumbnail?id=${url}&sz=w1000`;
    }

    async function processImageForShopify(imageUrl) {
      try {
        if (!imageUrl) return null;
        
        // Ha Drive ID-t találunk, generáljuk a megfelelő URL-t
        if (!imageUrl.startsWith('http')) {
          imageUrl = `https://drive.google.com/uc?export=view&id=${imageUrl}`;
        }
        
        return {
          src: imageUrl
        };
      } catch (error) {
        console.error('Hiba a kép feldolgozása során:', error);
        return null;
      }
    }

    function validateAndFormatImageUrl(url) {
      if (!url) return '';
      
      // Google Drive kép ID formázása
      if (!url.startsWith('http')) {
        return `https://drive.google.com/uc?export=view&id=${url}`;
      }
      
      return url;
    }

    function handleFileUpload(itemId) {
      const fileInput = document.getElementById(`files-${itemId}`);
      const fileList = document.getElementById(`fileList-${itemId}`);
      
      fileList.innerHTML = '';
      
      Array.from(fileInput.files).forEach(file => {
        if (!file.type.startsWith('image/')) {
          showError('Csak képfájlokat lehet feltölteni!');
          return;
        }

        const reader = new FileReader();
        reader.onload = function(e) {
          const fileItem = document.createElement('div');
          fileItem.className = 'file-item';
          fileItem.innerHTML = `
            <img src="${e.target.result}" alt="${file.name}">
            <button type="button" onclick="this.parentElement.remove()">×</button>
          `;
          fileList.appendChild(fileItem);
        };
        reader.readAsDataURL(file);
      });
    }

    function resetItemSelections(itemId) {
      const qualitySelect = document.getElementById(`quality-${itemId}`);
      const thicknessSelect = document.getElementById(`thickness-${itemId}`);
      const previewImg = document.getElementById(`preview-${itemId}`);
      const lengthInput = document.getElementById(`width-${itemId}`);
      const widthInput = document.getElementById(`height-${itemId}`);
      
      // Régi eseménykezelők eltávolítása
      removeOldEventHandlers(itemId);
      
      qualitySelect.innerHTML = '<option value="">Először válasszon faanyagot</option>';
      qualitySelect.disabled = true;
      
      thicknessSelect.innerHTML = '<option value="">Először válasszon minőséget</option>';
      thicknessSelect.disabled = true;
      
      // Méret mezők és korlátok alaphelyzetbe állítása
      lengthInput.value = '';
      lengthInput.removeAttribute('max');
      widthInput.value = '';
      widthInput.removeAttribute('max');
      
      previewImg.style.display = 'none';
      previewImg.src = '';
      
      // Paraméterek törlése
      const parametersContainer = document.getElementById(`parameters-${itemId}`);
      if (parametersContainer) {
        parametersContainer.innerHTML = '';
      }
      
      // Eseménykezelők törlése az objektumból
      delete eventHandlers[itemId];
      
      updatePrices();
    }

    function updatePrices() {
      let totalPrice = 0;
    
      items.forEach(itemId => {
        const material = document.getElementById(`material-${itemId}`).value;
        const quality = document.getElementById(`quality-${itemId}`).value;
        const thickness = document.getElementById(`thickness-${itemId}`).value;
        
        if (!material || !quality || !thickness) {
          document.getElementById(`unitPrice-${itemId}`).textContent = '0 Ft';
          document.getElementById(`itemTotal-${itemId}`).textContent = '0 Ft';
          return;
        }
    
        const width = parseFloat(document.getElementById(`width-${itemId}`).value) || 0;
        const height = parseFloat(document.getElementById(`height-${itemId}`).value) || 0;
        const quantity = parseInt(document.getElementById(`quantity-${itemId}`).value) || 0;
    
        const cacheKey = `${material}_${quality}_${thickness}`;
        const productDetails = cache.productDetails[cacheKey];
        
        if (productDetails) {
          const area = (width * height) / 1000000; // mm2 to m2
          let unitPrice = roundToFiveHUF(area * productDetails.m2_ár);
    
          // Él megmunkálás ár számítása
          const edgePrice = calculateEdgeProcessingPrice(itemId, width, height);
      
          // Felületkezelés ár számítása
          const surfacePrice = calculateSurfaceTreatmentPrice(itemId, area);
          
          // Egyedi forma ár számítása
          const shapePrice = calculateCustomShapePrice(itemId, area);
          
          // Teljes darabár
          const totalUnitPrice = unitPrice + edgePrice + surfacePrice + shapePrice;
          
          // Tételár
          const finalItemTotal = roundToFiveHUF(totalUnitPrice * quantity);
    
          // Árak megjelenítése
          document.getElementById(`unitPrice-${itemId}`).textContent = `${unitPrice.toLocaleString('hu-HU')} Ft`;
          document.getElementById(`edgePrice-${itemId}`).textContent = `${edgePrice.toLocaleString('hu-HU')} Ft`;
          document.getElementById(`surfacePrice-${itemId}`).textContent = `${surfacePrice.toLocaleString('hu-HU')} Ft`;
          document.getElementById(`shapePrice-${itemId}`).textContent = `${shapePrice.toLocaleString('hu-HU')} Ft`;
          document.getElementById(`itemTotal-${itemId}`).textContent = `${finalItemTotal.toLocaleString('hu-HU')} Ft`;
    
          totalPrice += finalItemTotal;
        }
      });
    
      document.getElementById('totalPrice').textContent = `${totalPrice.toLocaleString('hu-HU')} Ft`;
    }

    function calculateEdgeProcessingPrice(itemId, width, height) {
      const edgeSelect = document.getElementById(`edge-processing-${itemId}`);
      const selectedOption = edgeSelect.options[edgeSelect.selectedIndex];
      
      if (!selectedOption || !selectedOption.value) return 0;
      
      const pricePerMeter = parseFloat(selectedOption.dataset.price) || 0;
      let totalLength = 0;
      
      // Kiválasztott élek hosszának összegzése
      if (document.getElementById(`edge-top-${itemId}`).checked) {
        totalLength += width;
      }
      if (document.getElementById(`edge-bottom-${itemId}`).checked) {
        totalLength += width;
      }
      if (document.getElementById(`edge-left-${itemId}`).checked) {
        totalLength += height;
      }
      if (document.getElementById(`edge-right-${itemId}`).checked) {
        totalLength += height;
      }
      
      // mm to m conversion and price calculation
      return roundToFiveHUF((totalLength / 1000) * pricePerMeter);
    }
    
    // Felületkezelés ár számítása
    function calculateSurfaceTreatmentPrice(itemId, area) {
      const surfaceSelect = document.getElementById(`surface-treatment-${itemId}`);
      const selectedOption = surfaceSelect.options[surfaceSelect.selectedIndex];
      
      if (!selectedOption || !selectedOption.value) return 0;
      
      const pricePerM2 = parseFloat(selectedOption.dataset.price) || 0;
      return roundToFiveHUF(area * pricePerM2);
    }
    
    // Egyedi forma ár számítása
    function calculateCustomShapePrice(itemId, area) {
      const shapeSelect = document.getElementById(`custom-shape-${itemId}`);
      const selectedOption = shapeSelect.options[shapeSelect.selectedIndex];
      
      if (!selectedOption || !selectedOption.value) return 0;
      
      const pricePerM2 = parseFloat(selectedOption.dataset.price) || 0;
      return roundToFiveHUF(area * pricePerM2);
    }

    function fetchData(action, params = {}) {
      return new Promise((resolve, reject) => {
        const timestamp = Date.now();
        const callbackName = `callback_${timestamp}`;
        
        window[callbackName] = function(response) {
          clearTimeout(timeoutId);
          delete window[callbackName];
          document.head.removeChild(script);
          resolve(response);
        };

        const script = document.createElement('script');
        const queryParams = new URLSearchParams({
          ...params,
          action,
          callback: callbackName
        });

        script.src = `${SCRIPT_URL}?${queryParams.toString()}`;
        document.head.appendChild(script);

        const timeoutId = setTimeout(() => {
          delete window[callbackName];
          document.head.removeChild(script);
          reject(new Error('Időtúllépés a kérés során'));
        }, 10000);

        script.onerror = () => {
          clearTimeout(timeoutId);
          delete window[callbackName];
          document.head.removeChild(script);
          reject(new Error('Hálózati hiba történt'));
        };
      });
    }

    function resetItemPrices(itemId) {
      document.getElementById(`unitPrice-${itemId}`).textContent = '0 Ft';
      document.getElementById(`edgePrice-${itemId}`).textContent = '0 Ft';
      document.getElementById(`surfacePrice-${itemId}`).textContent = '0 Ft';
      document.getElementById(`shapePrice-${itemId}`).textContent = '0 Ft';
      document.getElementById(`itemTotal-${itemId}`).textContent = '0 Ft';
    }

    function validateContactForm() {
      const emailInput = document.getElementById('customerEmail');
      const phoneInput = document.getElementById('customerPhone');
      const continueBtn = document.getElementById('continueToPreviewBtn');
      const emailError = document.getElementById('emailError');
      const phoneError = document.getElementById('phoneError');
      
      let isValid = true;

      // Email validáció
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailInput.value) {
        emailError.textContent = 'Az email cím megadása kötelező';
        emailInput.classList.add('invalid');
        isValid = false;
      } else if (!emailRegex.test(emailInput.value)) {
        emailError.textContent = 'Kérjük, adjon meg egy érvényes email címet';
        emailInput.classList.add('invalid');
        isValid = false;
      } else {
        emailError.textContent = '';
        emailInput.classList.remove('invalid');
      }

      // Telefonszám validáció
      const phoneRegex = /^[0-9+\-\s()]{6,20}$/;
      if (!phoneInput.value) {
        phoneError.textContent = 'A telefonszám megadása kötelező';
        phoneInput.classList.add('invalid');
        isValid = false;
      } else if (!phoneRegex.test(phoneInput.value)) {
        phoneError.textContent = 'Kérjük, adjon meg egy érvényes telefonszámot';
        phoneInput.classList.add('invalid');
        isValid = false;
      } else {
        phoneError.textContent = '';
        phoneInput.classList.remove('invalid');
      }

      // Form validáció
      if (!validateForm()) {
        isValid = false;
      }

      // Gomb aktiválása/deaktiválása
      continueBtn.disabled = !isValid;
    }

    function showPreview() {
      if (!validateForm()) {
        showError('Kérjük, töltse ki az összes mezőt!');
        return;
      }
    
      // Kapcsolattartási űrlap megjelenítése
      document.getElementById('contactForm').style.display = 'block';
      document.getElementById('continueToPreviewBtn').style.display = 'none';
      
      // Preview container elrejtése amíg nincs kitöltve a kapcsolattartási űrlap
      document.getElementById('previewContainer').style.display = 'none';
      
      // Új gomb hozzáadása az űrlap elküldéséhez
      const submitBtn = document.createElement('button');
      submitBtn.id = 'submitContactForm';
      submitBtn.textContent = 'Adatok elküldése';
      submitBtn.onclick = submitContactForm;
      document.getElementById('contactForm').appendChild(submitBtn);
    }
    
    // Új függvény a kapcsolattartási űrlap kezeléséhez
    function submitContactForm() {
      const email = document.getElementById('customerEmail').value;
      const phone = document.getElementById('customerPhone').value;
      
      if (!email || !phone) {
        showError('Kérjük, töltse ki az összes kapcsolattartási adatot!');
        return;
      }
      
      // Email formátum ellenőrzése
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        showError('Kérjük, adjon meg egy érvényes email címet!');
        return;
      }
      
      // Telefonszám formátum ellenőrzése (egyszerű példa)
      const phoneRegex = /^[0-9+\-\s()]{6,20}$/;
      if (!phoneRegex.test(phone)) {
        showError('Kérjük, adjon meg egy érvényes telefonszámot!');
        return;
      }
    
      // Kapcsolattartási adatok mentése
      window.contactData = {
        customerEmail: email,
        customerPhone: phone
      };
    
      // Kapcsolattartási űrlap elrejtése
      document.getElementById('contactForm').style.display = 'none';
      
      // Preview megjelenítése
      displayPreview();
    }

    function displayPreview() {
      const email = document.getElementById('customerEmail').value;
      const phone = document.getElementById('customerPhone').value;

      // Kapcsolattartási adatok mentése
      window.contactData = {
        customerEmail: email,
        customerPhone: phone
      };

      const previewContainer = document.getElementById('previewContainer');
      const previewDetails = document.getElementById('previewDetails');
      
      let detailsHtml = '<h3>Megrendelt tételek</h3>';

      detailsHtml += `
      <div class="contact-details">
        <h4>Kapcsolattartási adatok</h4>
        <p><strong>Email:</strong> ${window.contactData.customerEmail}</p>
        <p><strong>Telefon:</strong> ${window.contactData.customerPhone}</p>
      </div>
    `;

      items.forEach((itemId, index) => {
        const material = document.getElementById(`material-${itemId}`).value;
        const quality = document.getElementById(`quality-${itemId}`).value;
        const thickness = document.getElementById(`thickness-${itemId}`).value;
        const width = document.getElementById(`width-${itemId}`).value;
        const height = document.getElementById(`height-${itemId}`).value;
        const quantity = document.getElementById(`quantity-${itemId}`).value;
        const unitPrice = document.getElementById(`unitPrice-${itemId}`).textContent;
        const itemTotal = document.getElementById(`itemTotal-${itemId}`).textContent;
        const previewImg = document.getElementById(`preview-${itemId}`);
        const fileList = document.getElementById(`fileList-${itemId}`);

        detailsHtml += `
          <div class="item-preview">
            <h4>Tétel #${index + 1}</h4>
            ${previewImg.src ? `<img src="${previewImg.src}" class="material-preview" alt="Anyag előnézet">` : ''}
            <p><strong>Faanyag:</strong> ${material}</p>
            <p><strong>Minőség:</strong> ${quality}</p>
            <p><strong>Vastagság:</strong> ${thickness}</p>
            <p><strong>Méret:</strong> ${width}mm × ${height}mm</p>
            <p><strong>Mennyiség:</strong> ${quantity} db</p>
            <p><strong>Darabár:</strong> ${unitPrice}</p>
            <p><strong>Tételérték:</strong> ${itemTotal}</p>
            
            ${fileList.children.length > 0 ? `
              <div class="file-list">
                <strong>Csatolt képek:</strong>
                <div class="file-upload-list">
                  ${Array.from(fileList.children)
                    .map(fileItem => `<img src="${fileItem.querySelector('img').src}" alt="Csatolt kép">`)
                    .join('')}
                </div>
              </div>
            ` : ''}
            <hr>
          </div>
        `;
      });

      detailsHtml += `
        <div class="total-price">
          <h3>Teljes összérték: ${document.getElementById('totalPrice').textContent}</h3>
        </div>
      `;

      previewDetails.innerHTML = detailsHtml;
      previewContainer.style.display = 'block';
      document.getElementById('continueToPreviewBtn').style.display = 'none';
    }

    function readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('Fájl olvasási hiba'));
        reader.readAsDataURL(file);
      });
    }

async function showPreview() {
  // Először ellenőrizzük, hogy minden szükséges adat megvan-e
  if (!validateForm()) {
    showError('Kérjük, töltse ki az összes mezőt!');
    return;
  }

  const email = document.getElementById('customerEmail').value;
  const phone = document.getElementById('customerPhone').value;

  if (!email || !phone) {
    showError('Kérjük, adja meg az elérhetőségi adatait!');
    return;
  }

  const loading = document.getElementById('loading');
  loading.style.display = 'block';

  try {
    const orderItems = [];
    
    // Minden tétel adatainak összegyűjtése és validálása
    for (const itemId of items) {
      const material = document.getElementById(`material-${itemId}`).value;
      const quality = document.getElementById(`quality-${itemId}`).value;
      const thickness = document.getElementById(`thickness-${itemId}`).value;
      
      // Termék részletek lekérése az árhoz
      const cacheKey = `${material}_${quality}_${thickness}`;
      const productDetails = cache.productDetails[cacheKey];
      
      if (!productDetails || !productDetails.m2_ár) {
        throw new Error('Hiányzó termék adatok vagy ár információ');
      }

      const width = parseInt(document.getElementById(`width-${itemId}`).value);
      const height = parseInt(document.getElementById(`height-${itemId}`).value);
      const quantity = parseInt(document.getElementById(`quantity-${itemId}`).value);

      // Ellenőrizzük, hogy minden szükséges adat megvan-e
      if (!material || !quality || !thickness || 
          !width || !height || !quantity || !productDetails.m2_ár ||
          isNaN(width) || isNaN(height) || isNaN(quantity)) {
        throw new Error('Hiányzó vagy érvénytelen tétel adatok');
      }

      // Méret validáció
      if (width < 100 || width > 3000 || 
          height < 100 || height > 3000 || 
          quantity < 1) {
        throw new Error('Érvénytelen méret vagy mennyiség');
      }

      // Ellenőrizzük a maximális méreteket
      if (productDetails.maxLength && width > productDetails.maxLength) {
        throw new Error(`A hosszúság nem lehet nagyobb, mint ${productDetails.maxLength}mm`);
      }
      if (productDetails.maxWidth && height > productDetails.maxWidth) {
        throw new Error(`A szélesség nem lehet nagyobb, mint ${productDetails.maxWidth}mm`);
      }

      // Árak számítása
      const area = (width * height) / 1000000; // mm2 to m2
      let unitPrice = roundToFiveHUF(area * productDetails.m2_ár);

      // Él megmunkálás opciók és ár
      const edgeProcessingSelect = document.getElementById(`edge-processing-${itemId}`);
      const selectedEdgeOption = edgeProcessingSelect.options[edgeProcessingSelect.selectedIndex];
      let edgeProcessingPrice = 0;
      let edgeProcessing = null;
      
      if (selectedEdgeOption && selectedEdgeOption.value) {
        const edgePrice = parseFloat(selectedEdgeOption.dataset.price) || 0;
        const selectedEdges = {
          topLength: document.getElementById(`edge-top-${itemId}`).checked,
          bottomLength: document.getElementById(`edge-bottom-${itemId}`).checked,
          leftWidth: document.getElementById(`edge-left-${itemId}`).checked,
          rightWidth: document.getElementById(`edge-right-${itemId}`).checked
        };
        
        let totalLength = 0;
        if (selectedEdges.topLength) totalLength += width;
        if (selectedEdges.bottomLength) totalLength += width;
        if (selectedEdges.leftWidth) totalLength += height;
        if (selectedEdges.rightWidth) totalLength += height;
        
        edgeProcessingPrice = roundToFiveHUF((totalLength / 1000) * edgePrice);
        edgeProcessing = {
          name: selectedEdgeOption.value,
          price: edgePrice,
          ...selectedEdges
        };
      }

      // Felületkezelés opciók és ár
      const surfaceTreatmentSelect = document.getElementById(`surface-treatment-${itemId}`);
      const selectedSurfaceOption = surfaceTreatmentSelect.options[surfaceTreatmentSelect.selectedIndex];
      let surfaceTreatmentPrice = 0;
      let surfaceTreatment = null;
      
      if (selectedSurfaceOption && selectedSurfaceOption.value) {
        const surfacePrice = parseFloat(selectedSurfaceOption.dataset.price) || 0;
        surfaceTreatmentPrice = roundToFiveHUF(area * surfacePrice);
        surfaceTreatment = {
          name: selectedSurfaceOption.value,
          price: surfacePrice
        };
      }

      // Egyedi forma opciók és ár
      const customShapeSelect = document.getElementById(`custom-shape-${itemId}`);
      const selectedShapeOption = customShapeSelect.options[customShapeSelect.selectedIndex];
      let customShapePrice = 0;
      let customShape = null;
      
      if (selectedShapeOption && selectedShapeOption.value) {
        const shapePrice = parseFloat(selectedShapeOption.dataset.price) || 0;
        customShapePrice = roundToFiveHUF(area * shapePrice);
        customShape = {
          name: selectedShapeOption.value,
          price: shapePrice
        };
      }

      // Teljes darabár (minden extra költséggel együtt)
      const totalUnitPrice = unitPrice + edgeProcessingPrice + surfaceTreatmentPrice + customShapePrice;
      
      // Tételár
      const lineItemTotal = roundToFiveHUF(totalUnitPrice * quantity);

      const item = {
        material,
        quality,
        thickness,
        width,
        height,
        quantity,
        imageUrl: document.getElementById(`preview-${itemId}`).src,
        uploadedImages: window.uploadedImages?.[itemId] || [],
        m2_ár: productDetails.m2_ár,
        edgeProcessing,
        surfaceTreatment,
        customShape,
        unitPrice: totalUnitPrice,
        lineItemTotal
      };

      orderItems.push(item);
    }

    const orderData = {
      items: orderItems,
      totalPrice: parseInt(document.getElementById('totalPrice').textContent.replace(/[^0-9]/g, '')),
      customerEmail: email,
      customerPhone: phone,
      orderDate: new Date().toISOString()
    };

    // Termék létrehozása
    const response = await fetch(SCRIPT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: `action=createProduct&data=${encodeURIComponent(JSON.stringify(orderData))}`
    });

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.error || 'Nem sikerült létrehozni a terméket');
    }

    createdVariantId = result.variantId;
    
    // Előnézet megjelenítése
    const previewContainer = document.getElementById('previewContainer');
    const previewDetails = document.getElementById('previewDetails');
    
    let detailsHtml = '<h3>Megrendelt tételek</h3>';

    // Kapcsolattartási adatok megjelenítése
    detailsHtml += `
      <div class="contact-details">
        <h4>Kapcsolattartási adatok</h4>
        <p><strong>Email:</strong> ${email}</p>
        <p><strong>Telefon:</strong> ${phone}</p>
      </div>
    `;

    orderItems.forEach((item, index) => {
      detailsHtml += `
        <div class="item-preview">
          <h4>Tétel #${index + 1}</h4>
          ${item.imageUrl ? `<img src="${item.imageUrl}" class="material-preview" alt="Anyag előnézet">` : ''}
          <p><strong>Faanyag:</strong> ${item.material}</p>
          <p><strong>Minőség:</strong> ${item.quality}</p>
          <p><strong>Vastagság:</strong> ${item.thickness}</p>
          <p><strong>Méret:</strong> ${item.width}mm × ${item.height}mm</p>
          <p><strong>Mennyiség:</strong> ${item.quantity} db</p>
          <p><strong>m² ár:</strong> ${item.m2_ár.toLocaleString('hu-HU')} Ft/m²</p>
          <p><strong>Alapár:</strong> ${item.unitPrice.toLocaleString('hu-HU')} Ft</p>
          ${item.edgeProcessing ? `
            <p><strong>Él megmunkálás:</strong> ${item.edgeProcessing.name}</p>
            <p><strong>Él megmunkálás ára:</strong> ${(item.edgeProcessing.price || 0).toLocaleString('hu-HU')} Ft/m</p>
          ` : ''}
          ${item.surfaceTreatment ? `
            <p><strong>Felületkezelés:</strong> ${item.surfaceTreatment.name}</p>
            <p><strong>Felületkezelés ára:</strong> ${(item.surfaceTreatment.price || 0).toLocaleString('hu-HU')} Ft/m²</p>
          ` : ''}
          ${item.customShape ? `
            <p><strong>Egyedi forma:</strong> ${item.customShape.name}</p>
            <p><strong>Egyedi forma ára:</strong> ${(item.customShape.price || 0).toLocaleString('hu-HU')} Ft/m²</p>
          ` : ''}
          <p><strong>Tételérték:</strong> ${item.lineItemTotal.toLocaleString('hu-HU')} Ft</p>
          
          ${item.uploadedImages.length > 0 ? `
            <div class="file-list">
              <strong>Csatolt képek:</strong>
              <div class="file-upload-list">
                ${item.uploadedImages
                  .map(img => `<img src="${img.previewUrl}" alt="Csatolt kép">`)
                  .join('')}
              </div>
            </div>
          ` : ''}
          <hr>
        </div>
      `;
    });

    detailsHtml += `
      <div class="total-price">
        <h3>Teljes összérték: ${document.getElementById('totalPrice').textContent}</h3>
      </div>
    `;

    previewDetails.innerHTML = detailsHtml;
    previewContainer.style.display = 'block';
    document.getElementById('addToCartBtn').style.display = 'block';
    document.getElementById('continueToPreviewBtn').style.display = 'none';

    // Email küldése
    const emailResponse = await fetch(SCRIPT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: `action=sendOrderEmails&data=${encodeURIComponent(JSON.stringify({
        ...orderData,
        variantId: result.variantId,
        productUrl: result.productUrl
      }))}`
    });

    const emailResult = await emailResponse.json();
    if (!emailResult.success) {
      throw new Error('Hiba történt az email küldése során');
    }
    
    showSuccess('A megrendelés sikeresen elküldve! Az értesítő emaileket kiküldtük.');

  } catch (error) {
    console.error('Error:', error);
    showError(error.message);
  } finally {
    loading.style.display = 'none';
  }
}


    function removeUploadedImage(itemId, fileName) {
      if (window.uploadedImages?.[itemId]) {
        window.uploadedImages[itemId] = window.uploadedImages[itemId].filter(img => img.name !== fileName);
      }
    }

    async function handleFileUpload(itemId) {
      const fileInput = document.getElementById(`files-${itemId}`);
      const fileList = document.getElementById(`fileList-${itemId}`);
      
      fileList.innerHTML = '';
      
      for (const file of fileInput.files) {
        if (!file.type.startsWith('image/')) {
          showError('Csak képfájlokat lehet feltölteni!');
          continue;
        }
    
        try {
          // Kép beolvasása és base64 konvertálás
          const base64Data = await readFileAsBase64(file);
          
          // Base64 adat tisztítása (metadata eltávolítása)
          const cleanBase64 = base64Data.split(',')[1];
          
          const fileItem = document.createElement('div');
          fileItem.className = 'file-item';
          fileItem.innerHTML = `
            <img src="${base64Data}" alt="${file.name}">
            <button type="button" onclick="removeUploadedImage('${itemId}', '${file.name}')">×</button>
          `;
          fileList.appendChild(fileItem);
    
          // Képadatok tárolása a további feldolgozáshoz
          if (!window.uploadedImages) {
            window.uploadedImages = {};
          }
          if (!window.uploadedImages[itemId]) {
            window.uploadedImages[itemId] = [];
          }
          window.uploadedImages[itemId].push({
            name: file.name,
            base64: cleanBase64,
            previewUrl: base64Data
          });
        } catch (error) {
          console.error('Hiba a fájl feldolgozása során:', error);
          showError('Hiba történt a kép feldolgozása során');
        }
      }
    }

    async function addToCart() {
      if (!createdVariantId) {
        showError('Hiba: A termék nem található');
        return;
      }
    
      const loading = document.getElementById('loading');
      loading.style.display = 'block';
    
      try {
        // Először megpróbáljuk közvetlenül a kosárhoz adni a terméket
        try {
          const cartResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: createdVariantId,
                quantity: 1
              }]
            })
          });
    
          if (cartResponse.ok) {
            // Ha sikeres volt a kosárhoz adás, átirányítunk a kosár oldalra
            window.location.href = '/cart';
            return;
          }
        } catch (cartError) {
          console.log('Kosárhoz adás sikertelen, próbálkozás a backup megoldással...');
        }
    
        // Ha nem sikerült közvetlenül a kosárhoz adni, használjuk a backend megoldást
        const response = await fetch(SCRIPT_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: `action=addToCart&variantId=${encodeURIComponent(createdVariantId)}`
        });
        
        const result = await response.json();
        
        if (!result.success) {
          throw new Error(result.error || 'Nem sikerült a kosárhoz adás');
        }
    
        // Ha van cart_url, használjuk azt
        if (result.cart_url) {
          window.location.href = result.cart_url;
        } 
        // Ha nincs cart_url, de van draft_order_url, használjuk azt
        else if (result.draft_order_url) {
          window.location.href = result.draft_order_url;
        }
        // Ha egyik sincs, csak jelezzük a sikert
        else {
          showSuccess('A termék sikeresen a kosárhoz adva!');
          document.querySelector('.post-add-buttons').style.display = 'grid';
          document.getElementById('addToCartBtn').style.display = 'none';
        }
    
      } catch (error) {
        console.error('Error:', error);
        showError(error.message);
      } finally {
        loading.style.display = 'none';
      }
    }

    function validateForm() {
      return items.every(itemId => {
        const material = document.getElementById(`material-${itemId}`).value;
        const quality = document.getElementById(`quality-${itemId}`).value;
        const thickness = document.getElementById(`thickness-${itemId}`).value;
        const width = document.getElementById(`width-${itemId}`).value;
        const height = document.getElementById(`height-${itemId}`).value;
        const quantity = document.getElementById(`quantity-${itemId}`).value;

        return material && quality && thickness &&
               width && height && quantity &&
               width >= 100 && width <= 3000 &&
               height >= 100 && height <= 3000 &&
               quantity >= 1;
      });

      return isItemsValid;
    }

    async function sendOrderEmails(orderData) {
      try {
        // Először létrehozzuk a terméket
        const createProductResponse = await fetch(SCRIPT_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: `action=createProduct&data=${encodeURIComponent(JSON.stringify(orderData))}`
        });

        const createResult = await createProductResponse.json();
        if (!createResult.success) {
          throw new Error(createResult.error || 'Nem sikerült létrehozni a terméket');
        }

        // Majd elküldjük az emaileket
        const sendEmailResponse = await fetch(SCRIPT_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: `action=sendOrderEmails&data=${encodeURIComponent(JSON.stringify({
            ...orderData,
            variantId: createResult.variantId
          }))}`
        });

        const emailResult = await sendEmailResponse.json();
        if (!emailResult.success) {
          throw new Error('Hiba történt az email küldése során');
        }

        return {
          success: true,
          variantId: createResult.variantId
        };
      } catch (error) {
        console.error('Rendelés feldolgozási hiba:', error);
        throw error;
      }
    }


    function resetForm() {
      items = [];
      document.getElementById('itemsList').innerHTML = '';
      document.getElementById('totalPrice').textContent = '0 Ft';
      document.querySelector('.post-add-buttons').style.display = 'none';
      document.getElementById('continueToPreviewBtn').style.display = 'block';
      document.getElementById('previewContainer').style.display = 'none';
      document.getElementById('successMessage').style.display = 'none';
      document.getElementById('errorMessage').style.display = 'none';
      
      addNewItem();
    }

    function showSuccess(message) {
      const successMessage = document.getElementById('successMessage');
      successMessage.textContent = message;
      successMessage.style.display = 'block';
      document.getElementById('errorMessage').style.display = 'none';
      
      // 5 másodperc után elrejtjük az üzenetet
      setTimeout(() => {
        successMessage.style.display = 'none';
      }, 5000);
    }

    function showError(message) {
      const errorDiv = document.getElementById('errorMessage');
      errorDiv.textContent = message;
      errorDiv.style.display = 'block';
      
      // Hibaüzenet automatikus eltüntetése 3 másodperc után
      setTimeout(() => {
        errorDiv.style.display = 'none';
      }, 3000);
    }
